// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { handleAction } from 'redux-actions';
import { GET_PROVINCES_DATA_SUCCESS } from './actions';

interface ProvinceType {
    ISOCode: string;
    ISOCountryNumber: number;
    ISOCountryShortCode: string;
    ISOName: string;
    ISOType: string;
    optionalZipcode: string;
}

export const INITIAL_STATE: {
    [key: string]: ProvinceType[];
} = {};

export type ProvinceStoreType = Readonly<typeof INITIAL_STATE>;

export default handleAction(
    GET_PROVINCES_DATA_SUCCESS,
    _getProvincesData,
    INITIAL_STATE
);

function _getProvincesData(
    state: any,
    { payload }: { payload: ProvinceType[] }
): ProvinceStoreType {
    if (payload) {
        const mappedProvinces = {};
        payload.map(province => mapProvince(mappedProvinces, province));
        return {
            ...state,
            ...mappedProvinces,
        };
    }
    return state;
}

//will create key value payer key=country code, value array of provinces for that country
function mapProvince(
    mappedProvinces: any,
    { ISOCode, ISOCountryShortCode, ISOName, ISOType }: any
) {
    const countryCodeKey = ISOCountryShortCode.toLowerCase();
    mappedProvinces[countryCodeKey] = [
        ...(mappedProvinces[countryCodeKey] || []),
        {
            ISOCode,
            ISOCountryShortCode,
            ISOName,
            ISOType,
        },
    ];
}
